import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCleaningExpList = createAsyncThunk(
  "cleaningExpList/getCleaningExpList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/housecleaning_exeperience/get_all_data`,

        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        data
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const cleaningExpListSlice = createSlice({
  name: "cleaningExpList",
  initialState: {
    loading: false,
    cleaningExpData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCleaningExpList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCleaningExpList.fulfilled, (state, action) => {
        state.loading = false;
        state.cleaningExpData = action.payload;
      })
      .addCase(getCleaningExpList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default cleaningExpListSlice.reducer;
